// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Frame4Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 24 15"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M20.768 6.572H4.984l3.468-3.467a1.156 1.156 0 000-1.675 1.156 1.156 0 00-1.674 0L1.277 6.931a1.156 1.156 0 000 1.674l5.5 5.5a1.156 1.156 0 001.675 0 1.156 1.156 0 000-1.673L4.984 8.964h15.784c.598 0 1.196-.478 1.196-1.196 0-.717-.598-1.196-1.196-1.196z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Frame4Icon
/* prettier-ignore-end */
